import React, { useEffect, useState } from 'react'
import { ChevronRight, ChevronLeft } from 'react-feather';

import StrapiLinkUnstyled from '../StrapiLink/StrapiLinkUnstyled';

import * as styles from './NavigationMobile.module.scss';


type NavigationMobileProps = {
  navigationItems: any;
  isOpen: boolean;
};

export const NavigationMobile = ({ navigationItems, isOpen }: NavigationMobileProps) => {
  const [childLinks, setChildLinks] = useState<any>([]);
  const [parentLink, setParentLink] = useState<any | null>(null);

  const handleClickParentLink = (link: any) => {
    setParentLink(link);
    setChildLinks(link.childLinks || []);
  };

  useEffect(() => {
    if (!isOpen) {
      setChildLinks([]);
    }
  }, [isOpen]);

  return (
    <div className={styles.root}>
      {navigationItems.map((item: any, idx: number) => {
        if (!item) return null;
        return (
          <div key={'parent-' + item.id + idx} className={styles.linkContainer}>
            {item.childLinks?.length ?
              <div className={styles.linkContainerWithIcon}>
                <StrapiLinkUnstyled  className={styles.genericLink} {...item.link}>
                  {item.title}
                </StrapiLinkUnstyled>
                <button className={styles.linkChevron} onClick={() => handleClickParentLink(item)}>
                  <ChevronRight size="16" />
                </button>
              </div>
            : item.link
              ?
                <StrapiLinkUnstyled className={styles.genericLink} {...item.link} onClick={() => setChildLinks([])}>
                  {item.title}
                </StrapiLinkUnstyled>
              : null
            }
          </div>
        );
      })}

      {parentLink && childLinks.length > 0 ?
        <div className={styles.childLinksContainer}>
          <div className={styles.backButtonContainer}>
            <button
              className={styles.backButton}
              onClick={() => setChildLinks([])}
            >
              <ChevronLeft size="16" />
              {parentLink.title}
            </button>
          </div>
          <div className={styles.childLinksInnerContainer}>
            {childLinks.map((link: any, idx: number) => (
              <div key={'child-' + link.id + idx} className={styles.linkContainer}>
                <StrapiLinkUnstyled  className={styles.genericLink} {...link}>
                  {link.title}
                </StrapiLinkUnstyled>
              </div>
            ))}
          </div>
        </div>
      : null }
    </div>
  )
}
